import { createSlice } from '@reduxjs/toolkit'

export const DynamicAssetSlice = createSlice({
  name: 'dynamic_asset',

  initialState: {
    projectRules : [],
    contacts : [],
    value: {}
  },
  reducers: {
    updateDynamicAssetValue: (state, action) => {
        if(action.payload.type){
            return { ...state,
                value:{
                  ...state.value,[action.payload.type]: action.payload.value
                }              
            }
        } else {
            state.value = action.payload
        }     
    },
    updateProjectRules: (state, action) => {
        state.projectRules = action.payload; 
    },
    updateProjectRuleLanguage: (state, action) => {
        let localProjectRules = JSON.parse(JSON.stringify(state.projectRules));
        let ruleValue = localProjectRules[action.payload.ruleIndex].ruleValues[action.payload.ruleValueIndex];
        ruleValue.language = action.payload.language;
        ruleValue.langDisplay = action.payload.langDisplay;
        ruleValue.langCode = action.payload.langCode;
        state.projectRules = localProjectRules;
    },
    updateContacts: (state, action) => {
      state.contacts = action.payload; 
    },
    addContact: (state, action) => {
      if (state.contacts === undefined) {
        state.contacts = [];
      }
      let isContactExists = false;
      state.contacts.map(contact => {
        if (contact.langCode === action.payload.langCode) {
          isContactExists = true;
          return;
        }
      }) 
      if (!isContactExists) {
        state.contacts.push(action.payload);
      } 
    },
    addReplaceContact: (state, action) => {
          if (state.contacts === undefined) {
            state.contacts = [];
          }
          let contacts = [];
          contacts.push(action.payload);
          state.contacts.map(contact => {
            if (contact.langCode !== action.payload.langCode) {
                contacts.push(contact);
            }
          })
          state.contacts = contacts;
    },
    removeContact: (state, action) => {
      state.contacts = state.contacts.filter(contact => {
        return contact.langCode !== action.payload.langCode
      })
    },
    resetDynamicAssets : state => {
        state.projectRules = [];
        state.contacts = [];
        state.value = {}
    }
  }
})

export const { updateDynamicAssetValue, updateProjectRules, resetDynamicAssets, updateProjectRuleLanguage, updateContacts, addContact, removeContact, addReplaceContact } = DynamicAssetSlice.actions

export default DynamicAssetSlice.reducer